<template>
  <div v-if="!loading && plan">
    <AllocationPoolView v-if="fundingType == 'allocation-pool'" :plan="plan" :certificates="certificates" />
    <CashAccountPlanView v-else :plan="plan" :certificates="certificates" />

    <va-modal
      v-if="showErrorMessage"
      v-model="showErrorMessage"
      title="Communication Error"
      close-button
    >
      <div>
        <p>There was an error connecting to the server.</p>
        <p>We were unable to obtain the data for this page at this time. Please try again later.</p>
      </div>
    </va-modal>
  </div>
</template>

<script>
import AllocationPoolView from "@/components/pages/AllocationPoolView.vue"
import CashAccountPlanView from "@/components/pages/CashAccountPlanView.vue"

export default {
	name: "CashAccount",

	components:{
		AllocationPoolView,
		CashAccountPlanView
	},

	data() {
		return {
			showErrorMessage: false,
			loading: false,
			plan: null,
			fundingType: null,
			certificates: [],
		}
	},

	computed: {
		plan_id() {
			return this.$route.params.id
		},
	},

	watch: {
		plan_id: {
			handler() {
				this.getSummary()
			}
		},
	},

	mounted() {
		this.getSummary()
	},

	methods: {
		getSummary() {
			this.loading = true
			this.$apiManager.get(`plans/cap/${this.plan_id}`)
				.then((result) => {
					this.plan = result.data
					this.fundingType = result.data.current.summary_data.plan.funding_type
					this.certificates = result.data.certificates
				})
				.catch((error) => {
					console.error(error)
				})
				.finally(() => {
					this.loading = false
				})
		},
	},
}
</script>

<style lang="scss" scoped>
</style>
